import { ClassifierService } from './../../services/classifier.service';
import { Component, Input, OnInit, ViewChild } from '@angular/core';

import { AppService } from '../../services/app.service';
import { NgForm } from '@angular/forms';
import { MessageService } from '../../services/message.service';
import { Message } from '../../models/Message';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { delay, finalize } from 'rxjs/operators';

export const simpleTextEditorCodes: string[] = [
    'FINAL_PAPER_AUTHENTICITY',
    'FINAL_PAPER_AUTHENTICITY_FULL',
    'FINAL_PAPER_RESTRICTION',
    'FINAL_PAPER_RESTRICTION_WARN',
    'FINAL_PAPER_PUBLIC'
];

const cache: {
    userRights?: {
        Code: string,
        Text: string
    }[]
} = {};

@Component({
    selector: 'app-message-edit',
    templateUrl: './message-edit.component.html',
    styleUrls: ['./messages.component.scss']
})
export class MessageEditComponent implements OnInit {
    constructor(
        private app: AppService,
        private service: MessageService,
        private classifiers: ClassifierService,
        private activeModal: NgbActiveModal
    ) { }

    @Input() set data(value: Message) {
        Object.assign(this.item, value);
    }

    readonly item = new Message();

    title: string;
    userRights: { Code: string, Text: string }[] = [];
    isNew: boolean;
    isSaving: boolean;

    readonly editorConfig = {
        convert_urls: false,
        forced_root_block: '',
        entity_encoding: 'raw',
        plugins: 'link textcolor table code lists',
        toolbar:
            'formatselect | bold italic forecolor backcolor'
            + ' | alignleft aligncenter alignright alignjustify | bullist numlist | removeformat'
            + ' | table link | code'
    };


    @ViewChild('form', { static: false }) private form: NgForm;

    ngOnInit() {
        if (cache.userRights) {
            this.userRights = cache.userRights;
        } else {
            this.app.addLoading(this.classifiers.getUdr()).subscribe(data => {
                this.userRights = cache.userRights = data.filter(r => r.Code.startsWith("UDR")).map(t => ({ Code: t.Code, Text: t.Value }));
            });
        }
    }

    isRichEditor(): boolean {
        return simpleTextEditorCodes.indexOf(this.item.Code) === -1;
    }

    save() {
        if (!this.form.valid) {
            this.app.alert.warning(this.app.translate('invalidFormWarning'));
            return;
        }

        this.isSaving = true;

        const success = () => {
            this.activeModal.close();
        };

        const req = this.item.Id
            ? this.service.update(this.item.Id, this.item)
            : this.service.create(this.item);

        req.pipe(delay(500), finalize(() => this.isSaving = false)).subscribe(success);
    }

    cancel() {
        this.activeModal.dismiss();
    }
}
